/**
 * @store 门户 企业 模块
 */

import {api} from "@/api";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // 首页Banner
    async querySearch(_, data) {
      return await api.post(`/api/article/search`, data);
    },
    // 首页Banner
    async queryBanner(_, data) {
      return await api.post(`/api/article/getBanner`, data);
    },
    // 首页新闻
    async queryNews() {
      return await api.post(`/api/index/news`);
    },
    // 热门政策
    async queryPolicyList() {
      return await api.post(`/api/article/newsList`, {
        "page": 1,
        "pageSize": 9,
        "type": "policy_analysis"
      });
    },
    // 热门政策排行
    async queryPolicyRank() {
      return await api.post(`/api/article/newsList`, {
        "page": 1,
        "pageSize": 9,
        "type": "policy"
      });
    },
    // 热门技术
    async queryHeatTechnology() {
      return await api.post(`/api/article/mediaWithPic`);
    },
    // 最新技术
    async queryNewestTechnology() {
      return await api.post(`/api/article/medialists`, {
        "category": "new_technique",
        "keyword": "",
        "pageSize": 5,
        "p": 1
      });
    },
    // 推荐供货
    async querySupply() {
      return await api.post(`/api/trade/getListByType`, {
        "type": 1,
        "sort": 1,
        "sortType": 1,
        "page": 1,
        "pageSize": 5,
        "keywords": ""
      });
    },
    // 推荐需求
    async queryDemand() {
      return await api.post(`/api/trade/getListByType`, {
        "type": 2,
        "sort": 1,
        "sortType": 1,
        "page": 1,
        "pageSize": 5,
        "keywords": ""
      });
    },
  },
}
